import { Component, Input, OnChanges } from '@angular/core';
import { ColumnDef } from '../../../shared/data-table/data-table.model';
import { ProgressOverviewRow } from '../../../_models/reports/progress-overview-row.model';

/** Row shape with the derived display fields the table binds to. */
interface ProgressOverviewViewRow extends ProgressOverviewRow {
    studentName: string;
    sectionLabelText: string;
}

@Component({
    selector: 'progress-overview-report',
    templateUrl: 'progress-overview-report.component.html',
    styleUrls: ['progress-overview-report.component.css'],
    standalone: false
})
export class ProgressOverviewReportComponent implements OnChanges {

    @Input() rows: ProgressOverviewRow[];

    public columns: ColumnDef<ProgressOverviewViewRow>[] = [
        { field: 'sectionLabelText', header: 'Section', sortable: true },
        { field: 'studentName', header: 'Learner', sortable: true },
        { field: 'clientName', header: 'Client', sortable: true },
        { field: 'tutor', header: 'Tutor', sortable: true },
        { field: 'dated', header: 'Date', type: 'date', sortable: true },
        { field: 'initialKeyStageCode', header: 'Initial Key Stage', sortable: true },
        { field: 'initialGradeDescription', header: 'Initial Grade', sortable: true },
        { field: 'targetKeyStageCode', header: 'Target Key Stage', sortable: true },
        { field: 'targetGradeDescription', header: 'Target Grade', sortable: true },
        { field: 'targetDescription', header: 'Target', sortable: true }
    ];

    public tableRows: ProgressOverviewViewRow[] = [];

    ngOnChanges(): void {
        const source = this.rows != null ? this.rows : [];
        this.tableRows = source.map(row => ({
            ...row,
            studentName: `${row.studentFirstName} ${row.studentLastName}`,
            sectionLabelText: this.sectionLabel(row.section)
        }));
    }

    /** section is "B" (baseline) or "P" (progress/outcome) on the wire. */
    private sectionLabel(section: string): string {
        return section === 'B' ? 'Baseline' : section === 'P' ? 'Progress' : section;
    }
}
